(() => {
  'use strict';

  const SECTION_SELECTOR = '.compact-pdp-section';
  const MODAL_CLASS = 'compact-lightbox';

  const pauseMedia = (scope) => {
    scope.querySelectorAll('video').forEach((video) => video.pause());

    scope.querySelectorAll('model-viewer').forEach((model) => {
      if (typeof model.pause === 'function') model.pause();
    });

    scope.querySelectorAll('iframe').forEach((frame) => {
      if (!frame.contentWindow) return;

      frame.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
        '*'
      );
      frame.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
    });
  };

  const rawMediaId = (value) => {
    if (!value) return null;
    return value.split('-').pop();
  };

  const enhanceLightbox = (section) => {
    const sectionId = section.dataset.section;
    const modal = document.getElementById('ProductModal-' + sectionId);

    if (!modal || modal.dataset.compactLightboxEnhanced === 'true') return;

    const dialog = modal.querySelector('.product-media-modal__dialog');
    const content = modal.querySelector('.product-media-modal__content');
    const slides = content
      ? Array.from(content.children).filter((child) => child.hasAttribute('data-media-id'))
      : [];

    if (!dialog || !content || slides.length === 0) return;

    modal.dataset.compactLightboxEnhanced = 'true';
    modal.classList.add(MODAL_CLASS);

    const controls = document.createElement('div');
    controls.className = 'compact-lightbox__controls';
    controls.innerHTML = [
      '<button type="button" class="compact-lightbox__button compact-lightbox__button--previous" aria-label="Previous media">',
      '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"/></svg>',
      '</button>',
      '<p class="compact-lightbox__counter" aria-live="polite" aria-atomic="true">',
      '<span data-lightbox-current>1</span>',
      '<span aria-hidden="true"> / </span>',
      '<span class="visually-hidden"> of </span>',
      '<span data-lightbox-total>' + slides.length + '</span>',
      '</p>',
      '<button type="button" class="compact-lightbox__button compact-lightbox__button--next" aria-label="Next media">',
      '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6"/></svg>',
      '</button>'
    ].join('');

    dialog.appendChild(controls);

    // Sense closes media modals on any mouse pointer release; keep navigation inside the lightbox.
    controls.addEventListener('pointerup', (event) => event.stopPropagation());

    const previousButton = controls.querySelector('.compact-lightbox__button--previous');
    const nextButton = controls.querySelector('.compact-lightbox__button--next');
    const currentLabel = controls.querySelector('[data-lightbox-current]');
    let currentIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('active')));

    if (slides.length === 1) controls.hidden = true;

    const showSlide = (index) => {
      currentIndex = Math.min(Math.max(index, 0), slides.length - 1);

      slides.forEach((slide, slideIndex) => {
        const isCurrent = slideIndex === currentIndex;
        slide.hidden = !isCurrent;
        slide.classList.toggle('active', isCurrent);
        slide.setAttribute('aria-hidden', String(!isCurrent));

        if (!isCurrent) pauseMedia(slide);
      });

      currentLabel.textContent = String(currentIndex + 1);
      previousButton.disabled = currentIndex === 0;
      nextButton.disabled = currentIndex === slides.length - 1;
    };

    previousButton.addEventListener('click', () => showSlide(currentIndex - 1));
    nextButton.addEventListener('click', () => showSlide(currentIndex + 1));

    dialog.addEventListener('keydown', (event) => {
      const isRtl = document.documentElement.dir === 'rtl';

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(currentIndex + (isRtl ? 1 : -1));
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(currentIndex + (isRtl ? -1 : 1));
      }
    });

    section.addEventListener('click', (event) => {
      const opener = event.target.closest('modal-opener.product__modal-opener');
      if (!opener) return;

      const mediaItem = opener.closest('[data-media-id]');
      const mediaId = rawMediaId(mediaItem ? mediaItem.dataset.mediaId : null);
      const requestedIndex = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);

      window.requestAnimationFrame(() => {
        showSlide(requestedIndex >= 0 ? requestedIndex : 0);
      });
    });

    showSlide(currentIndex);
  };

  const initialize = (root) => {
    if (root.matches && root.matches(SECTION_SELECTOR)) enhanceLightbox(root);
    root.querySelectorAll(SECTION_SELECTOR).forEach(enhanceLightbox);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();